import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { shipmentUploadTableCustomStyles } from "../../../utils/TableCustomStyles";
import { format } from "date-fns";
import { ConvertPdfToImage } from "../../../utils/ConvertPdfToImage";
import moment from "moment-timezone";



function PlannedExportUploads(props) {
  const adduploadform = useRef(null);
  const [shipmentUploadData, setShipmentUploadData] = useState([]);
  const [shipmentUploadDataPending, setShipmentUploadDataPending] = useState(true);

  const shipment_id = props.shipmentId
  const currentUserRolePermissionData = props.currentUserRolePermissionData
  const loggedInUser = props.loggedInUser

  // ----------------------- CRO --------------------------------
  const [showAddShipmentUploadModal, setShowAddShipmentUploadModal] = useState(false);
  const [showDeleteShipmentUploadModal, setShowDeleteShipmentUploadModal] = useState(false);
  const [showUploadShipmentUploadStatusModal, setShowShipmentUploadStatusModal] = useState(false);

  const [addShipmentUploadLoader, setAddShipmentUploadLoader] = useState(false);
  const [deleteShipmentUploadLoader, setDeleteShipmentUploadLoader] = useState(false);
  const [shipmentUploadStatusLoader, setShipmentUploadStatusLoader] = useState(false);
  
  const [shipmentUploadId, setShipmentUploadId] = useState(null);
  const [shipmentUploadFile, setShipmentUploadFile] = useState(null);
  const [shipmentUploadType, setShipmentUploadType] = useState("");
  const [enableUploadButton, setEnableUploadButton] = useState(false);
  const [uploadVerificationStatus, setUploadVerificationStatus] = useState("PENDING_VERIFICATION");
  const [verificationComment, setVerificationComment] = useState("");


  const getShipmentUploads = async (shipment_id) => {
    setShipmentUploadDataPending(true)
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentupload?booking=' + shipment_id);
      if (response) {
        setShipmentUploadData(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching shipment uploads data! Try again.");
    }
    setShipmentUploadDataPending(false)
  }

  useEffect(() => {
    getShipmentUploads(shipment_id)
  }, [shipment_id]);


  const shipmentuploadscolumns = [
    {
      name: 'File',
      width: '150px',
      selector: row => <img src={row.screenshot} height={141} width={100} className="border" />,
      sortable: true,
    },
    {
      name: 'Upload Type',
      width: '200px',
      selector: row => row.upload_type.replaceAll("_", " "),
      sortable: true,
    },
    {
      name: 'Details',
      width: '400px',
      selector: row => <>
        <span><b>File Name: </b>{row.file_name}</span><br></br>
        <span><b>File Type: </b>{row.file_type}</span><br></br>
        <span><b>File Size: </b>{row.file_size + " MB"}</span><br></br>
        <span><b>Uploaded By: </b>{row.created_by_data?.name}</span><br></br>
        <span><b>Uploaded On: </b>{format(new Date(row.created_on), "dd-MM-yyyy h:m a")}</span><br></br>
      </>,
      sortable: true,
    },
    {
      name: 'Status',
      width: '220px',
      selector: row => 
        <div className="d-flex flex-row">
          <i className={`mr-3 mt-2 ${row.status == "VERIFIED"? "fa fa-circle text-success": row.status == "REJECTED"? "fa fa-circle text-danger":"fa fa-circle-o text-muted"}`}></i>
          {loggedInUser?.role_array?.includes("superadmin") ?
          <select className={`form-control form-select-sm `} 
                  onChange={(e) => handleShowUploadStatusModal(row, e.target.value)}>
            <option value="" selected={row.status == "" ? true : false} disabled>Select Status</option>
            <option value="PENDING_VERIFICATION" selected={row.status == "PENDING_VERIFICATION" ? true : false} className={row.status == "PENDING_VERIFICATION" ? "text-dark" : ""} disabled>PENDING VERIFICATION</option>
            <option value="VERIFIED" selected={row.status == "VERIFIED" ? true : false} className={row.status == "VERIFIED" ? "bg-inox-green text-white" : ""}>VERIFIED</option>
            <option value="REJECTED" selected={row.status == "REJECTED" ? true : false} className={row.status == "REJECTED" ? "bg-inox-red text-white" : ""}>REJECTED</option>
          </select>
          :
          row.status ?? "-"}
        </div>,
      sortable: true,
    },
    {
      name: 'Verification',
      width: '230px',
      selector: row => <>
        <span><b>Verified By: </b>{row.verified_by_data?.name ?? "None"}</span><br></br>
        <span><b>Verified On: </b>{row.verified_on ? format(new Date(row.verified_on), "dd-MM-yyyy h:m a") : "None"}</span><br></br>
      </>,
      sortable: true,
    },
    {
      name: 'Comments',
      width: '350px',
      selector: row => row.comment ?? "-",
      sortable: true,
      wrap: true,
      style: {
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        lineHeight: '1.2',
      },
    },
    {
      name: 'Action',
      width: '110px',
      center: true,
      selector: row =>
        <div>
          {
            currentUserRolePermissionData?.includes("shipment:uploaddocument:view") ?
              <a href={row.screenshot} target="_blank">
                <Button className="btn btn-sm btn-inox-green my-1 mx-1 border-0" style={{ height: 30 }} title="View">
                  <i className="fa fa-eye"></i>
                </Button>
              </a>
              :
              ""
          }

          {
            currentUserRolePermissionData?.includes("shipment:uploaddocument:delete") ?
              <Button className="btn btn-sm btn-danger my-1 mx-1" style={{ height: 30 }} title="Delete" onClick={() => handleShowDeleteShipmentUploadModal(row)}
              disabled={row.status == "VERIFIED"|row.status == "REJECTED"?true:false}>
                <i className="fa fa-trash"></i>
              </Button>
              :
              ""
          }
        </div>,
    }
  ];

  const handleShowAddShipmentUploadModal = () => {
    setShowAddShipmentUploadModal(true)
  }

  const handleCloseAddShipmentUploadModal = () => {
    setShowAddShipmentUploadModal(false)
    setShipmentUploadFile(null)
  }

  const handleShowDeleteShipmentUploadModal = (data) => {
    setShipmentUploadId(data?.id)
    setShowDeleteShipmentUploadModal(true)
  }

  const handleCloseDeleteShipmentUploadModal = () => {
    setShipmentUploadId("")
    setShowDeleteShipmentUploadModal(false)
  }

  const handleShowUploadStatusModal = (data, status) => {
    setShipmentUploadId(data?.id)
    setUploadVerificationStatus(status)
    setShowShipmentUploadStatusModal(true)
  }

  const handleCloseUploadStatusModal = () => {
    setShowShipmentUploadStatusModal(false)
  }

  const addShipmentUpload = async (e) => {
    e.preventDefault();
    setAddShipmentUploadLoader(true)

    const data = {
      "shipment": shipment_id,
      "upload": shipmentUploadFile,
      "upload_type": adduploadform.current.upload_type.value,
      "uploaded_by": loggedInUser?.id,
      "created_by": loggedInUser?.id
    }

    try {
      const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentupload/addshipmentuploads/', data, { headers: { "Content-Type": "multipart/form-data" } });

      if (response.status == 201) {
        toast.success("File uploaded successfully");
      }
    } catch (err) {
      toast.error("Error in uploading file! Try again.");
    }

    setShipmentUploadFile(null)
    adduploadform.current.shipment_upload.value = ""
    adduploadform.current.upload_type.value = ""
    getShipmentUploads(shipment_id)
    setAddShipmentUploadLoader(false)
    setShowAddShipmentUploadModal(false)
  }


  const deleteShipmentUpload = async (e) => {
    e.preventDefault();
    setDeleteShipmentUploadLoader(true)

    const id = shipmentUploadId

    try {
      const response = await axios.delete(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentupload/' + id + '/');

      if (response.status == 204) {
        toast.success("File deleted successfully");
        getShipmentUploads(shipment_id)
      }
    } catch (err) {
      toast.error("Error in deleting file! Try again.");
    }
    setDeleteShipmentUploadLoader(false)
    setShowDeleteShipmentUploadModal(false)
  }

  const setUploadStatus = async (e) => {
    e.preventDefault();
    setShipmentUploadStatusLoader(true)

    const id = shipmentUploadId
    const datetime_now = moment().tz("Asia/Kolkata").format("YYYY-MM-DDTHH:mm:ssZ")

    const data = {
      id: id,
      status: uploadVerificationStatus,
      comment: verificationComment,
      verified_by: loggedInUser?.id,
      verified_on: datetime_now,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentupload/'+id+'/', data, { headers: { 'content-type': 'application/json' } });

    if (response.status === 200) {
      toast.success("Files Status Updated Successfully")
    }

    getShipmentUploads(shipment_id)
    setShipmentUploadStatusLoader(false)
    setShowShipmentUploadStatusModal(false)
  }

  const setShipmentUploadComment = async (id, remarks) => {
    const data = {
      id: id,
      shipment: shipment_id,
      remarks: remarks,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentupload/' + id + '/', data, { headers: { 'content-type': 'application/json' } });

    if (response.status === 200) {
      toast.success("Comment added Successfully")
    }

    getShipmentUploads(shipment_id)
  }

  const createUploadFile = async (files) => {
    const uploadFiles = await Promise.all(
      Array.from(files).map(async (file) => {
        const screenshot = file.type === "application/pdf"
          ? await ConvertPdfToImage(file)
          : "";

        return {
          file,
          previewUrl: URL.createObjectURL(file),
          screenshot
        };
      })
    );

    return uploadFiles;
  };

  const handleUploadsFileChange = async (file) => {
    const uploadfile = await createUploadFile(file);
    setShipmentUploadFile(uploadfile);
  }

  useEffect(() => {
    if (shipmentUploadFile?.length > 0 && shipmentUploadType != "") {
      setEnableUploadButton(true)
    }
    else {
      setEnableUploadButton(false)
    }
  }, [shipmentUploadFile, shipmentUploadType]
  )


  return (
    <div>
      <div className="col-12 text-left" style={{ marginTop: -5 }}>
        <div className="row">
          <div className="col-9">
            <Button className="btn btn-inox-green border-0" onClick={() => handleShowAddShipmentUploadModal()}>Upload</Button>
          </div>
        </div>


        <DataTable
          columns={shipmentuploadscolumns}
          data={shipmentUploadData}
          progressPending={shipmentUploadDataPending}
          progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
          noDataComponent={<p className="text-center table-no-data">No Uploads Found</p>}
          highlightOnHover
          customStyles={shipmentUploadTableCustomStyles}
          dense
        />
      </div>

      {/*  --------------------------- Upload --------------------------- */}
      <Modal size="lg" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showAddShipmentUploadModal} onHide={() => handleCloseAddShipmentUploadModal()} centered>
        <Modal.Header closeButton>
          <Modal.Title>Upload File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form ref={adduploadform}>
            <div className="row">
              <div className="col-6">
                <input type="file"
                  className="form-control"
                  id="shipment_upload"
                  name="shipment_upload"
                  accept="application/pdf"
                  onChange={(e) => handleUploadsFileChange(e.target.files)}
                />
              </div>

              <div className="col-6">
                <select className="form-select" id="upload_type" name="upload_type" onChange={(e) => setShipmentUploadType(e)}>
                  <option value="">Select Type</option>
                  <option value="POL_BL" >POL BL</option>
                  <option value="EXPORT_PERMIT">EXPORT PERMIT</option>
                  <option value="SHIPPING_BILL">SHIPPING BILL</option>
                  <option value="VGM">VGM</option>
                  <option value="HAZ_DOCS">HAZ DOCS</option>
                  <option value="UNDERTAKING_LOI">UNDERTAKING/LOI</option>
                  <option value="SIGNED_FIRST_ORIGINAL">SIGNED FIRST ORIGINAL</option>
                  <option value="SIGNED_SECOND_ORIGINAL">SIGNED SECOND ORIGINAL</option>
                  <option value="SIGNED_THIRD_ORIGINAL">SIGNED THIRD ORIGINAL</option>
                  <option value="SIGNED_SURRENDER_BL">SIGNED SURRENDER BL</option>
                  <option value="SIGNED_EXPRESS_BL">SIGNED EXPRESS BL</option>
                  <option value="SIGNED_SEAWAY_BL">SIGNED SEAWAY BL</option>
                  <option value="OTHERS">OTHERS</option>
                </select>
              </div>
            </div>

            {shipmentUploadFile?.length > 0 ?
              <div className="row mt-5">
                <div className="col-12" style={{ fontSize: 12, textAlign: 'left' }}>
                  <table width={'100%'}>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Preview</th>
                      <th>File Name</th>
                      <th>File Size</th>
                      <th>File Type</th>
                    </tr>

                    {shipmentUploadFile?.map((upload, index) => (
                      <tr>
                        <td>{index + 1}</td>
                        <td><iframe src={upload?.previewUrl} style={{ width: '120px', height: 'auto', display: 'block', marginBottom: '0.5rem', border: '1px solid lightgrey' }} /></td>
                        <td>{upload.file.name}</td>
                        <td>{(upload.file.size / 1024).toFixed(2)} KB</td>
                        <td>{upload.file.type}</td>
                      </tr>
                    ))}
                  </table>
                </div>
              </div>
              : ""}

            <div className="row mt-5">
              <div className="col-12 text-center mt-4">
                <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => handleCloseAddShipmentUploadModal()}>Cancel</Button>
                <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => addShipmentUpload(e)} disabled={enableUploadButton ? false : true}>
                  {addShipmentUploadLoader ?
                    <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    :
                    "Upload"
                  }
                </Button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>


      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showDeleteShipmentUploadModal} onHide={() => handleCloseDeleteShipmentUploadModal()} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are your sure you want to delete this file?</p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-12 text-center mt-4">
              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => handleCloseDeleteShipmentUploadModal()}>Cancel</Button>
              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => deleteShipmentUpload(e)}>
                {deleteShipmentUploadLoader ?
                  <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  :
                  "Delete"
                }
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showUploadShipmentUploadStatusModal} onHide={() => handleCloseUploadStatusModal()} centered>
        <Modal.Header closeButton>
          <Modal.Title>{uploadVerificationStatus=="VERIFIED"?"Verify Uploaded File":"Reject Uploaded File"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="form-group">
            <label>Comment</label>
            <textarea className="form-control w-100" cols={4} onChange={(e) => setVerificationComment(e.target.value)}></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-12 text-center mt-4">
              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => handleCloseUploadStatusModal()}>Cancel</Button>
              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => setUploadStatus(e)}>
                {shipmentUploadStatusLoader ?
                  <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  :
                  "Update"
                }
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default PlannedExportUploads;
